import { Component, inject } from '@angular/core';
import { ToasterService } from '../../services/toaster/toaster.service';

@Component({
  selector: 'app-toaster',
  imports: [],
  templateUrl: './toaster.html',
  styleUrl: './toaster.scss',
})
export class Toaster {
  public toasterService = inject(ToasterService);
  public toasts = this.toasterService.toasts;

  dismiss(id: string) {
    this.toasterService.dismiss(id);
  }
}
